import styled from 'styled-components';

export const Main = styled.main`
  min-height: 100vh;
`;
